import { useState } from 'react';
import { Video } from '@havenengineering/module-haven-content';
import { GalleryItem } from '../../../../types/shared';
import { handleAccommodationGalleryOverlay } from '../../../../helpers/gtm/gtm-shared';
import { SearchResultImage } from '../../../../types/v3/api-response';
import { ParkFeatureWithImageAndIcon } from '../../../../helpers/carouselItems';
import { DataLayerProduct } from '../../../../types/analytics';
import { Image } from '../../../caravan-details-page/types/index';

export type HandleAccommodationGalleryGeneralProps = {
  activeTab: string;
  accommodationName: string;
  caravanImages: SearchResultImage[] | Image[];
  matterPortId: string;
  floorPlan: string;
  parkCode: string;
  parkName: string;
  parkFeatures: ParkFeatureWithImageAndIcon[];
  accomGrade: string;
  accommodationType: string;
  products: DataLayerProduct[];
  video?: Video;
  isCaravanSearch?: boolean;
  caravanImagesSource?: string;
};

export type HandleAccommodationGalleryGeneral = ({
  activeTab,
  accommodationName,
  caravanImages,
  matterPortId,
  floorPlan,
  parkCode,
  parkName,
  parkFeatures,
  accomGrade,
  accommodationType,
  products,
  isCaravanSearch,
  caravanImagesSource,
}: HandleAccommodationGalleryGeneralProps) => void;

export const useAccommodationGallery = () => {
  const [resultToShowInGalleryGeneral, setResultToShowInGalleryGeneral] = useState<GalleryItem>();
  const [activeTabStateGeneral, setActiveTabStateGeneral] = useState('accommodation');
  const [showAccommodationGalleryGeneral, setShowAccommodationGalleryGeneral] = useState(false);

  const handleAccommodationGalleryGeneral = ({
    activeTab,
    accommodationName,
    caravanImages,
    matterPortId,
    floorPlan,
    parkCode,
    parkName,
    parkFeatures,
    accomGrade,
    accommodationType,
    products,
    video,
    isCaravanSearch,
    caravanImagesSource,
  }: HandleAccommodationGalleryGeneralProps) => {
    setResultToShowInGalleryGeneral({
      accommodationName,
      caravanImages,
      matterPortId,
      floorPlan,
      parkCode,
      parkName,
      parkFeatures,
      accomGrade,
      accomType: accommodationType,
      products,
      video,
    });
    setActiveTabStateGeneral(activeTab);
    setShowAccommodationGalleryGeneral(true);
    handleAccommodationGalleryOverlay(
      activeTab,
      accommodationType.toLowerCase() || '',
      accomGrade.toLowerCase() || '',
      !!floorPlan,
      !!matterPortId,
      products,
      isCaravanSearch,
      caravanImagesSource,
    );
  };

  return {
    handleAccommodationGalleryGeneral,
    resultToShowInGalleryGeneral,
    activeTabStateGeneral,
    showAccommodationGalleryGeneral,
    setShowAccommodationGalleryGeneral,
  };
};
